import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { DrugCompanyService } from "./drug-company.service";
import { IDrugCompany } from "./idrug-company";

@Injectable({
    providedIn: 'root'
})
export class DrugCompanyResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _drugCompanyService: DrugCompanyService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, drugCompanyDetails: IDrugCompany[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._drugCompanyService.getAllDrugComapany(data);
    }
}